import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

// Tags que o backend substitui ao gerar o documento do termo.
const AVAILABLE_TAGS = [
  { tag: 'NOME_PACIENTE', description: 'nome do paciente' },
  { tag: 'TELEFONE_PACIENTE', description: 'telefone do paciente' },
  { tag: 'CPF_PACIENTE', description: 'CPF do paciente' },
  { tag: 'NOME_DENTISTA', description: 'nome do dentista' },
  { tag: 'DATA_ATUAL', description: 'data em que o termo é gerado' },
  { tag: 'CIDADE_CLINICA', description: 'cidade da clínica' },
];

// Instruções de preparo do .docx, compartilhadas pelas telas web e mobile.
export default function TermInstructionsDialog({ open, onClose, fullScreen }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" fullScreen={fullScreen}>
      <DialogTitle sx={{ fontWeight: 'bold', alignItems: 'center' }}>
        <InfoOutlined sx={{ mr: 1 }} />
        Como preparar seu modelo de documento
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          <Typography gutterBottom>
            Para que o sistema consiga gerar o termo corretamente, você deve inserir tags no texto
            do seu arquivo Word (.docx) nos locais onde as informações devem aparecer.
          </Typography>
          <Typography sx={{ mt: 2, mb: 2 }} variant="body2" component="div">
            <strong>Exemplo:</strong>
            <Box sx={{ padding: 1, backgroundColor: 'action.hover', mt: 1 }}>
              O paciente {'{NOME_PACIENTE}'} está de acordo com o procedimento realizado.
            </Box>
          </Typography>
          <Typography gutterBottom>
            As tags serão substituídas automaticamente pelos dados reais de cada paciente.
          </Typography>
          <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
            <strong> Tags disponíveis para uso:</strong>
          </Typography>
          <ul>
            {AVAILABLE_TAGS.map((availableTag) => (
              <li key={availableTag.tag}>
                <Typography variant="body2" component="span">
                  <strong>{`{${availableTag.tag}}`}</strong> — {availableTag.description}
                </Typography>
              </li>
            ))}
          </ul>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" fullWidth={fullScreen}>
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  );
}

TermInstructionsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool,
};

TermInstructionsDialog.defaultProps = {
  fullScreen: false,
};
